export { default } from './richContent';
